import "./Team.scss";

import { useTranslation } from "react-i18next";

import aleksanderImg from "../../../assets/img/team/aleksander.png";
import corentinImg from "../../../assets/img/team/corentin.png";
import Section from "../../../components/Section/Section";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";
import TeamCard from "./TeamCard/TeamCard";

const MEMBER_IMAGES: Record<string, string> = {
  Corentin: corentinImg,
  Aleksander: aleksanderImg,
};

const Team = () => {
  const { t } = useTranslation();

  const members = t("team.members", { returnObjects: true }) as Array<{
    initial: string;
    name: string;
    role: string;
    bio: string;
  }>;

  const panelItems = t("team.panel.items", { returnObjects: true }) as Array<{
    label: string;
    value: string;
  }>;

  return (
    <Section id="team" className="team">
      <SectionHeader
        tag={t("team.tag")}
        title={t("team.title")}
        subtitle={t("team.subtitle")}
      />
      <div className="teamContent">
        <div className="teamGrid fi">
          {members.map((member) => (
            <TeamCard
              key={member.name}
              initial={member.initial}
              name={member.name}
              role={member.role}
              bio={member.bio}
              image={MEMBER_IMAGES[member.name]}
            />
          ))}
        </div>
        <div className="teamPanel fi">
          <div className="teamPanelAccentBar" />
          <div className="teamPanelDecor">03</div>
          <div className="teamPanelLabel">{t("team.panel.label")}</div>
          <div className="teamPanelItems">
            {panelItems.map((item, index) => (
              <div key={index} className="teamPanelItem">
                <span className="teamPanelKey">{item.label}</span>
                <span className="teamPanelVal">{item.value}</span>
              </div>
            ))}
          </div>
          <div className="teamPanelDivider" />
          <p className="teamPanelStatement">{t("team.panel.statement")}</p>
        </div>
      </div>
    </Section>
  );
};

export default Team;
